import { RootState } from 'redux/schemas';
import { RolesService } from 'institutions/services/roles-service';
import { Role } from 'redux/schemas/models/role';

export const getRoles = (state: RootState): Role[] => Object.values(state.models.roles);

export const getLearnerRoles = (state: RootState): Role[] => Object.values(state.models.roles).filter(role => RolesService.isLearner(role));
